export async function initSlideshows() {
  if (document.querySelector(".image-slideshow-block")) {
    const [{ Splide }] = await Promise.all([
      import("@splidejs/splide"),
      // @ts-ignore
      import("@splidejs/splide/dist/css/splide.min.css"),
    ]);
    const splide = new Splide(".splide", {
      type: "loop",
      gap: "1rem",
      pagination: false,
    });
    splide.mount();
  }
}
